import { useEffect } from 'react'
import { BoxDropFile, Button } from '@iveco-ti/iveco-ds'
import { useFormContext } from '@iveco-ti/iveco-ds/hook-form'
import { ImageUp, Trash } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import DefaultIMG from '@/assets/images/post-default.svg'
import { useEditNewsStore } from '../stores/useEditNewsStore'

export function FormEditNewsImage() {
  const { t } = useTranslation('panel')
  const { setValue, getValues, ...hookForm } = useFormContext()
  const { news } = useEditNewsStore()

  const handleRemoveImage = () => {
    setValue('postImage', null)
    setValue('image', null)
  }

  const NEW_IMAGE = hookForm.watch('image')
  const IMAGE = hookForm.watch('postImage')

  useEffect(() => {
    const IMAGE_TO_CROP = getValues('image')

    if (
      !IMAGE_TO_CROP ||
      (Array.isArray(IMAGE_TO_CROP) && !IMAGE_TO_CROP.length)
    ) {
      setValue('postImage', news?.postImage)
      setValue('image', undefined)
    }
  }, [getValues, setValue, news])

  return (
    <div className="h-full flex flex-col gap-6">
      <h2 className="text-2xl text-sky-700 font-semibold">
        {t('news.drawer_edit_news.crop.title')}
      </h2>

      {(!NEW_IMAGE || (Array.isArray(NEW_IMAGE) && !NEW_IMAGE.length)) &&
        NEW_IMAGE !== null && (
          <img
            src={IMAGE ? (news?.postImage as string) : DefaultIMG}
            className="rounded mt-4 max-h-52 w-full object-cover object-center"
          />
        )}

      <BoxDropFile.Root>
        <BoxDropFile.Input
          name="image"
          title={t('news.drawer_create_news.fields.image.title')}
          description={t('news.drawer_create_news.fields.image.description')}
          accept={{ 'image/jpeg': [], 'image/png': [], 'image/webp': [] }}
        >
          <BoxDropFile.Icon icon={<ImageUp />} />
        </BoxDropFile.Input>
      </BoxDropFile.Root>

      {news?.postImage && NEW_IMAGE !== null && !news?.isSlider && (
        <Button.Root
          variant="secondary"
          color="danger"
          className="w-fit"
          onClick={handleRemoveImage}
        >
          <Button.Icon icon={Trash} />
          {t('news.drawer_edit_news.fields.image.button_remove')}
        </Button.Root>
      )}
    </div>
  )
}
